import React from "react";
import GenAIContent from "../FunctionComponents/GenAIFolder/GenAIContent";

function GenAI() {
  return (
    <>
      <GenAIContent />
    </>
  );
}

export default GenAI;
